import React from 'react';
import { ListItem, ListItemIcon, ListItemText } from '@mui/material';
import { Skeleton } from '@mui/material';
import { ListMenuSkeletonProps } from './ListMenuSkeleton.props';

// Styles are passed as props from parent component

const ListMenuSkeleton = ({ open, classes }: ListMenuSkeletonProps) => (
  <ListItem className={classes.item}>
    <ListItemIcon>
      <Skeleton variant="circular" width={28} height={28} className={classes.skeleton} />
    </ListItemIcon>
    {open && <ListItemText primary={<Skeleton variant="text" className={classes.skeleton} height={30} />} />}
  </ListItem>
);

export default ListMenuSkeleton;
